(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fl-recipes-slider"] && !Shopify.designMode) return;
  try {
    
  
  window.addEventListener('load', function () {

    setTimeout(function(){
			gsap.registerPlugin(ScrollTrigger);

			const sections = gsap.utils.toArray(".scroll-slide-section-item");
			let maxWidth = 0;

			const getMaxWidth = () => {
			  maxWidth = 0;
			  sections.forEach((section) => {
				maxWidth += section.offsetWidth;
			  });
			};
			getMaxWidth();
			ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

			gsap.to(sections, {
			  x: () => `-${maxWidth - window.innerWidth}`,
			  ease: "none",
			  scrollTrigger: {
				trigger: ".scroll-slide-section",
				pin: true,
				scrub: true,
				end: () => `+=${maxWidth}`,
				invalidateOnRefresh: true
			  }
			});

			sections.forEach((sct, i) => {
			  ScrollTrigger.create({
				trigger: sct,
				start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
				end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
				toggleClass: {targets: sct, className: "active"}
			  });
			});
      window.dispatchEvent(new Event('resize'));//Trigger the window resize to resolve the bug from ScrollTrigger
		}, 1000);


		$('.scrolling-section-inner').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: false,
			arrows: false,
			dots: true,
			responsive: [{
				breakpoint: 1450,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}]
		});

  }, false);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-recipes-smores-slider"] && !Shopify.designMode) return;
  try {
    
  
  window.addEventListener('load', function () {

    setTimeout(function(){
			gsap.registerPlugin(ScrollTrigger);

			const sections = gsap.utils.toArray(".scroll-slide-section-item");
			let maxWidth = 0;

			const getMaxWidth = () => {
			  maxWidth = 0;
			  sections.forEach((section) => {
				maxWidth += section.offsetWidth;
			  });
			};
			getMaxWidth();
			ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

			gsap.to(sections, {
			  x: () => `-${maxWidth - window.innerWidth}`,
			  ease: "none",
			  scrollTrigger: {
				trigger: ".scroll-slide-section",
				pin: true,
				scrub: true,
				end: () => `+=${maxWidth}`,
				invalidateOnRefresh: true
			  }
			});

			sections.forEach((sct, i) => {
			  ScrollTrigger.create({
				trigger: sct,
				start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
				end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
				toggleClass: {targets: sct, className: "active"}
			  });
			});
      window.dispatchEvent(new Event('resize'));//Trigger the window resize to resolve the bug from ScrollTrigger
		}, 1000);


		$('.scrolling-section-inner').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: false,
			arrows: false,
			dots: true,
            adaptiveHeight: true,
			responsive: [{
				breakpoint: 1450,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}]
		});

  }, false);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  (()=>{
    window.addEventListener('resize', () => {
      const footerHeight = document.querySelector('.shopify-section-group-footer-group').offsetHeight;
      document.body.style.paddingBottom = `${footerHeight}px`;
    })
    window.dispatchEvent(new Event('resize'));
  })()



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);



(() => {
  let currentScrollTop = 0,
  timer = null;
  let preserveState = false;
  const header = document.querySelector('.section-header');
  const headerBounds = header.getBoundingClientRect()
  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom && !preserveState) {
      header.classList.add('scrolled-past-header');
    } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom && !preserveState) {
      header.classList.add('scrolled-past-header');
    } else if (scrollTop <= headerBounds.top) {
      header.classList.remove('scrolled-past-header');
    }

    clearTimeout(timer);
    timer = setTimeout(() => {
      preserveState = true;
      header.classList.remove('scrolled-past-header');
      setTimeout(() => {
        preserveState = false;
      }, 500)
    }, 800);

    currentScrollTop = scrollTop;

  }, false);

})()



  } catch(e) { console.error(e); }
})();
})();
